<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Overview</span>
        <h3 class="page-title">User Profile</h3>
      </d-col>
    </d-row>

    <!-- Content -->
    <d-row>
      <d-col lg="4">
        <upl-user-details/>
      </d-col>
      <d-col lg="8">
        <upl-user-account-details :user="User"/>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import UserDetails from '_modules/settings/components/UserDetails.vue';
import UserAccountDetails from '_modules/settings/components/UserAccountDetails.vue';
import MODEL from '../components/UserModel';

export default {
  name: 'user-profile-lite',
  components: {
    uplUserDetails: UserDetails,
    uplUserAccountDetails: UserAccountDetails,
  },
  computed: {
    User() {
      const { user } = this.$store.state.user;
      if (user) {
        return user;
      }
      return MODEL;
    },
  },
};
</script>

